import { FC } from "react";
import { Line } from "@ant-design/charts";

const MultiLineChart: FC<any> = (props) => {

  const legendPosition : any = "bottom"
  const data = props?.data ? props.data : [];

  const config = {
    data,
    xField: "x",
    yField: "y",
    seriesField: 'legend',
    legend: { position: legendPosition },
    tooltip: {
      domStyles:{
        "g2-tooltip": {backgroundColor:"#091e42", color:"#fff", borderRadius:"8px"}
      }
  },
  theme:{
    colors10: ["#559fa6", "#ef8c58", "#9e6ae5", "#e75547"]
  }
    
  };
  return <Line {...config} />;
};

export default MultiLineChart;
